var upgrade_modal = function (
  e,
  limit,
  message,
  plan_to_display,
  event_type,
  prevent_close,
  wistia_id
) {
  console.log(plan_to_display, message);

  if (e !== undefined && e !== "event") {
    e.preventDefault();
  }

  var modal_div = $("#upgrade");
  var gate_div = $(
    '.feature-gate-content[data-plan-type="' + plan_to_display + '"]'
  );
  var message_div = $(gate_div).find(".feature-message");
  var current_plan_type = $(modal_div).attr("data-plan-type");
  var websites_plan = $(modal_div).attr("data-websites-plan");
  var website_premium = $(modal_div).attr("data-website-premium");
  var website_plan = $(modal_div).attr("data-website-plan");

  // Explicit Remix/Paid/Prime gates should bypass premium website override
  var plan_type_to_use =
    ["paid", "prime", "remix"].includes(plan_to_display)
      ? plan_to_display
      : // override plan_to_display if just a premium website upgrade is needed
      current_plan_type !== "free" &&
        website_premium == "false" &&
        websites_plan
      ? "premium_website"
      : current_plan_type == "marketer"
      ? "legacy"
      : plan_to_display;

  // Update Wistia embed if wistia_id is provided
  if (wistia_id) {
    var wistia_responsive_padding = $(modal_div).find(
      ".wistia_responsive_padding"
    );
    $(wistia_responsive_padding).attr("data-id", wistia_id);
    $(wistia_responsive_padding).html(`
      <div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">
        <div class="wistia_embed wistia_async_${wistia_id} seo=false videoFoam=true" style="height:100%;position:relative;width:100%">
          <img src="https://fast.wistia.com/embed/medias/${wistia_id}/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="if (this.parentNode) this.parentNode.style.opacity=1;" />
        </div>
      </div>
    `);

    $.getScript("https://fast.wistia.com/assets/external/E-v1.js");
    $.getScript("https://fast.wistia.com/embed/medias/" + wistia_id + ".jsonp");
  }

  // Bootstrap removes body.modal-open when any modal hides, even if another
  // modal (e.g. #integrations) is still open. Builder modal scroll depends on
  // body.modal-open, so restore it after the upgrade gate closes.
  $(modal_div)
    .off("hidden.bs.modal.restoreModalOpen")
    .on("hidden.bs.modal.restoreModalOpen", function () {
      if ($(".modal.in:visible").length > 0) {
        $("body").addClass("modal-open");
      }
    });

  $(modal_div).modal({
    show: true,
    backdrop: prevent_close ? "static" : true,
    keyboard: !prevent_close,
  });
  $(".modal-backdrop").css("z-index", "1");

  if (prevent_close) {
    $(modal_div).find(".close").hide();
    $(modal_div).find(".upgrade-go-back").show();
  } else {
    $(modal_div).find(".upgrade-go-back").hide();
  }

  if (plan_type_to_use) {
    $(".feature-gate-content").hide();
    $(
      '.feature-gate-content[data-plan-type="' + plan_type_to_use + '"]'
    ).show();

    if (["plus", "enterprise"].includes(plan_type_to_use)) {
      $.getScript(
        "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
      );
    }
  }

  if (message) {
    $(message_div).text(message);
  }

  if (event_type) {
    userEvent(event_type);
  }
};

export default upgrade_modal;
